<template>
  <div>
    <LoadingSpinner
      v-if="isLoading"
      :status="$t('envelope.loadingEnvelope')"
    />

    <PasswordEntryScreen
      v-else-if="passwordNeeded"
      :passwordStatus="passwordStatus"
      :callback="fetchEnvelope"
      :branding="branding"
    />

    <OtpScreen
      v-else-if="otpStatus.showDialog"
      :getEnvelope="fetchEnvelope"
      :branding="branding"
    />

    <div
      v-else
      class="container bg-lightGray"
    >
      <AppHeader :title="title" />
      <SideBarInfo />
      <Document />
      <DocumentFooter />
      <Help />
      <RejectDocument />
      <WidgetVerify />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import AppHeader from '@/components/Header'

import SideBarInfo from '@/components/SideBarInfo'
import Help from '@/components/Help'
import RejectDocument from '@/components/RejectDocument'
import WidgetVerify from '@/components/WidgetVerify'
import Document from '@/components/Document'
import DocumentFooter from '@/components/Footer'
import LoadingSpinner from '@/components/LoadingSpinner'
import PasswordEntryScreen from '@/components/screens/PasswordEntryScreen.vue'
import OtpScreen from '@/components/screens/OtpScreen.vue'

export default {
  name: 'EnvelopePage',
  components: {
    SideBarInfo,
    Help,
    RejectDocument,
    WidgetVerify,
    Document,
    DocumentFooter,
    AppHeader,
    LoadingSpinner,
    PasswordEntryScreen,
    OtpScreen
  },
  data () {
    return {
      isLoading: true,
      scrollTop: 0
    }
  },
  mounted () {
    window.addEventListener('scroll', (event) => {
      this.toggleDocumentNav(event)
      this.toggleProgressBar(event)
    })

    this.$bus.$on('scrollBody', () => { // Scroll document to active field
      const header = document.querySelectorAll('header')
      const headerHeight = header[0].firstChild.clientHeight + 70
      const currentId = this.$store.state.activeFieldId
      const input = document.querySelectorAll(`.document-field[data-id="${currentId}"]`)
      if (input.length > 0) {
        const scrollAmount = this.getOffset(input[0])
        this.$SmoothScroll((scrollAmount - headerHeight), 500)
      }
    })
  },
  computed: {
    ...mapGetters({
      branding: 'branding',
      passwordStatus: 'auth/passwordStatus',
      passwordNeeded: 'auth/passwordNeeded',
      otpStatus: 'auth/otpStatus',
      title: 'title'
    })
  },
  created () {
    if (this.$route.name === 'Preview' || this.$route.name === 'BulkSendPreview') {
      window.IS_PREVIEW = true
    }

    this.fetchEnvelope()

    this.$bus.$on('loading', () => {
      this.isLoading = true
    })

    this.$bus.$on('loadingStop', () => {
      this.isLoading = false
    })

    this.$bus.$on('submitEnvelope', ({ response }) => {
      if (response.status === 'verify') {
        let redirectUrl = this.$store.getters.widgetRedirectUrl

        if (redirectUrl) {
          if (!redirectUrl.match(/^https:\/\/|^http:\/\//g)) {
            // Add http:// if not provided
            redirectUrl = `http://${redirectUrl}`
          }
          // Evaluate string as URL object
          redirectUrl = new URL(redirectUrl)

          window.location.replace(redirectUrl)
        } else {
          this.$router.push({
            name: 'WidgetSigned',
            params: {
              widgetCode: this.$route.params.widgetCode
            }
          }).catch(error => {
            console.error(error)
          })
        }
      } else {
        this.fetchEnvelope()
      }
    })
  },
  watch: {
    currentDocumentIndex () {
      const body = document.getElementsByTagName('body')[0]
      body.scrollTop = 0
      document.documentElement.scrollTop = 0
    }
  },
  methods: {
    getOffset (el) {
      const element = el.getBoundingClientRect()
      return element.top + (window.scrollY || window.pageYOffset)
    },
    toggleDocumentNav () {
      const windowScrollHeight = window.scrollTop || window.pageYOffset
      if ((windowScrollHeight + window.innerHeight) >= document.body.offsetHeight) {
        this.$bus.$emit('scrolledToBottom', { isBottom: true })
      } else {
        this.$bus.$emit('scrolledToBottom', { isBottom: false })
      }
    },
    toggleProgressBar () {
      const scrollTop = window.scrollTop || window.pageYOffset
      if (scrollTop > this.scrollTop + 20) {
        this.$bus.$emit('scrollingDown')
      } else if (scrollTop < (this.scrollTop - 20)) {
        this.$bus.$emit('scrollingUp')
      }
      if (scrollTop === 0) {
        this.$bus.$emit('scrollingUp')
      }
      this.scrollTop = scrollTop
    },
    fetchEnvelope (password) {
      this.$store.dispatch('getEnvelope', {
        query: this.$route.query,
        password: password || this.passwordStatus.password,
        widgetCode: this.$route.params.widgetCode
      }).finally(() => {
        this.isLoading = false
      })
    }
  }
}
</script>

<style lang="sass" scoped>
  .overlay
    position: absolute
    top: 0
    left: 0
    height: 100%
    width: 100%
    background: rgba(0, 0, 0, 0.6)
    z-index: 999
  .float-right
    float: right
</style>
